export const L10N = {
  LABEL_CHOOSE_DESTINATION: { id: 'lisa.label.choose_destination' },
  LABEL_HI: { id: 'lisa.label.hi' },
  LABEL_HOW_HELP: { id: 'lisa.label.how_help' },

  LABEL_MODE_AUDIO_TITLE: { id: 'lisa.label.mode_audio_title' },
  LABEL_MODE_AUDIO_DESCRIPTION: { id: 'lisa.label.mode_audio_description' },
  LABEL_MODE_TEXT_TITLE: { id: 'lisa.label.mode_text_title' },
  LABEL_MODE_TEXT_DESCRIPTION: { id: 'lisa.label.mode_text_description' },
  LABEL_MODE_WHATSAPP_TITLE: { id: 'lisa.label.mode_whatsapp_title' },
  LABEL_MODE_WHATSAPP_DESCRIPTION: { id: 'lisa.label.mode_whatsapp_description' },
};
